import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface OtherProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Other: React.FC<OtherProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [other, setOther] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Additional Features']?.['Other'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Additional Features': { ...s.values?.['Additional Features'], Other: v } } })
    );
    const label = 'Other';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={other}
                />
            ) : (
                <TextBox
                    value={other ?? ''}
                    onChange={(value) => setOther(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
